// Original, generated notification chimes (no copyrighted audio).
// Synthesized with the Web Audio API. Plays once per call.
let _ctx = null;

function ctx() {
  if (!_ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    _ctx = new AC();
  }
  return _ctx;
}

export function unlockAudio() {
  const c = ctx();
  if (c && c.state === "suspended") c.resume().catch(() => {});
}

export const CHIME_TONES = [
  { id: "bandara", label: "Bandara (ding-dong)" },
  { id: "lembut", label: "Lembut" },
  { id: "bel", label: "Bel Klinik" },
];

// [freq, startOffset(s), dur(s)]
const SEQ = {
  bandara: { notes: [[659.25, 0.0, 0.6], [523.25, 0.5, 0.7], [659.25, 1.2, 0.6], [523.25, 1.7, 1.0]], shimmer: true, peak: 0.5 },
  lembut: { notes: [[587.33, 0.0, 0.7], [880.0, 0.5, 1.1]], shimmer: false, peak: 0.38 },
  bel: { notes: [[1046.5, 0.0, 1.3], [1318.5, 0.0, 1.3], [1046.5, 0.6, 1.4], [1318.5, 0.6, 1.4]], shimmer: false, peak: 0.34 },
};

export function playNotifChime(volume = 0.9, tone = "bandara") {
  try {
    const c = ctx();
    if (!c) return;
    if (c.state === "suspended") c.resume().catch(() => {});
    const vol = Math.max(0, Math.min(1, Number.isFinite(volume) ? volume : 0.9));
    const spec = SEQ[tone] || SEQ.bandara;
    const master = c.createGain();
    master.gain.value = vol;
    master.connect(c.destination);
    const t0 = c.currentTime + 0.03;
    spec.notes.forEach(([f, off, dur]) => {
      const harms = spec.shimmer ? [1, 2] : [1];
      harms.forEach((h, i) => {
        const o = c.createOscillator();
        const g = c.createGain();
        o.type = "sine";
        o.frequency.value = f * h;
        const peak = i === 0 ? spec.peak : 0.12;
        const st = t0 + off;
        g.gain.setValueAtTime(0.0001, st);
        g.gain.exponentialRampToValueAtTime(peak, st + 0.03);
        g.gain.exponentialRampToValueAtTime(0.0001, st + dur);
        o.connect(g);
        g.connect(master);
        o.start(st);
        o.stop(st + dur + 0.05);
      });
    });
  } catch (e) {
    /* ignore */
  }
}


// Browser/device Text-to-Speech announcement (id-ID). Privacy-safe: caller
// decides the exact phrase (no phone/NIK/address/medical/payment data).
export function speakAnnouncement(text, volume = 0.9) {
  try {
    if (!("speechSynthesis" in window) || !text) return;
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "id-ID";
    u.rate = 1.0;
    u.pitch = 1.0;
    u.volume = Math.max(0, Math.min(1, Number.isFinite(volume) ? volume : 0.9));
    const voices = window.speechSynthesis.getVoices() || [];
    const idv = voices.find((v) => /id[-_]?ID/i.test(v.lang)) || voices.find((v) => /indones/i.test(v.name));
    if (idv) u.voice = idv;
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(u);
  } catch (e) {
    /* ignore */
  }
}

